import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Overline, Reveal } from "@/components/motion";
import TourCard from "@/components/site/TourCard";
import { getTours } from "@/lib/api";

export default function PopularTours({ title, subtitle }) {
  const [tours, setTours] = useState([]);
  useEffect(() => {
    getTours({ featured: true }).then((d) => setTours(d.slice(0, 8))).catch(() => {});
  }, []);

  return (
    <section id="tours" data-testid="home-tours" className="relative py-24 sm:py-32 bg-[#fdfbf7]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <Overline>{title || "Popular Tour Packages"}</Overline>
            <h2 className="font-serif text-[#3b1a1a] text-4xl sm:text-6xl leading-[1.03] tracking-tight mt-5">
              Journeys our travellers <span className="italic text-[#7c1d1d]">dream about.</span>
            </h2>
          </div>
          <Link to="/tours" className="inline-flex items-center gap-2 text-xs tracking-[0.24em] uppercase text-[#7c1d1d] hover:gap-3 transition-all">
            View All Tours <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {tours.map((t, i) => (
            <Reveal key={t.id} delay={(i % 4) * 0.06}>
              <TourCard tour={t} index={i} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
